import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-message-popup',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './message-popup.component.html',
    styleUrls: ['./message-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessagePopupComponent {
  message="no message";
  message2="";
  btnActive:string|null=null;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { message: string; message2?: string; btnActive?:string },
    private dialogRef: MatDialogRef<MessagePopupComponent>,
  ) {
    if (data.message) {
      this.message=data.message;
    }
    if (data.message2) {
      this.message2=data.message2;
    }
    if (data.btnActive) {
      this.btnActive=data.btnActive;
    }
    //  else {  this.name.setValue(`page ${data.index+1}`) }
    dialogRef.disableClose = true;
  }
  cancel() {
    this.dialogRef.close(false);
  }
  save() {
    this.dialogRef.close(true);
  }
}
